import React from 'react';
import AvailableOption from './availableoption';
import '@styles/customise/option.scss';
import { AvailableOption as AvailableOptionData } from '@tsapiclient/zenauto.vehiclequotation.ts.client/interfaces/availableoption';
import { useSelectedOptions } from '@hooks/useselectedoptions';

export interface OptionsListProps {
  availableOptions: AvailableOptionData[];
  variant: 'trim' | 'hood' | 'optional' | 'colour';
  dataTestId?: string;
}

const OptionsList: React.FC<OptionsListProps> = ({
  availableOptions,
  variant,
  dataTestId,
}) => {
  const { selectOption } = useSelectedOptions();

  return (
    <>
      <div
        data-testid={dataTestId}
        data-cy={dataTestId}
        className="customise-options__content"
      >
        {availableOptions.map((option, index) => (
          <AvailableOption
            key={index}
            variant={variant}
            option={option}
            setSelectedOption={selectOption}
          />
        ))}
      </div>
    </>
  );
};

export default OptionsList;
